

const Loader = () => <div className="loader-2 center"><span></span></div>    


export default Loader;